import React, { useEffect, useState } from "react"
import { onEnterKeyPress, useIsMobile } from "@src/utils/general"

const ProductFeatures = ({ items }) => {
  const [activeItem, setActiveItem] = useState(null)
  const isMobile = useIsMobile()

  useEffect(() => {
    setActiveItem(items[0])
  }, [items])

  if (isMobile) {
    return (
      <div className="flex flex-col w-full">
        {items?.map((item) => (
          <div 
            key={`accordion-${item.title}`} 
            className="border-t border-gray-200 last:border-b"
          >
            <button
              onClick={() => setActiveItem(activeItem?.title === item.title ? null : item)}
              className="w-full flex justify-between items-center py-4 px-4"
            >
              <span className="text-sm font-medium text-gray-900">{item.title}</span>
              <span className="text-gray-500">
                {activeItem?.title === item.title ? '−' : '+'}
              </span>
            </button>
            {activeItem?.title === item.title && (
              <div className="px-4 pb-4">
                {item.content}
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div
      className="flex flex-col w-full"
      aria-label="Product Features"
      aria-hidden={false}
      tabIndex={0}
    >
      <div className="product-features antialiased flex space-x-6">
        {items?.map(({ title }) => (
          <p
            key={`heading-${title}`}
            className={`
    ${
      activeItem?.title === title
        ? "product-features-item--active text-sm mt-5 pb-2"
        : "product-features-item--inactive text-sm mt-5 pb-2"
    } product-features-item`}
            onClick={() =>
              setActiveItem(items.find(item => item.title === title))
            }
            onKeyDown={e =>
              onEnterKeyPress(e, () =>
                setActiveItem(items.find(item => item.title === title))
              )
            }
            aria-label={`${title} Tab`}
            tabIndex={0}
          >
            {title}
          </p>
        ))}
      </div>
      <div className="flex w-full gap-x-12 mt-4 justify-between">
        <div className="col-span-12 w-full">{activeItem?.content}</div>
        {/* {(currentVariant?.variantFeaturesImage || currentVariant?.listingImage || currentVariant?.variantImages?.[0]) && 
                <div className="hidden md:block md:w-[350px] md:h-[370px] flex-shrink-0">
                    <Image
                        image={currentVariant?.variantFeaturesImage || currentVariant?.listingImage || currentVariant?.variantImages?.[0]}
                        width={350}
                        height={300}
                        className={'rounded-xl object-cover'}
                    />
                </div>} */}
      </div>
    </div>
  )
}

export default ProductFeatures
